import coffeeShop from '@/assets/img/users-cases/coffee-shop.webp';
import coffeeShopHow from '@/assets/img/users-cases/coffee-shop-how.webp';
import coffeeShopResult from '@/assets/img/users-cases/coffee-shop-result.webp';

export default {
  slug: '3D-tour-coffee-shop',
  order: 5,
  title: '3D Tour Coffee Shop',
  subtitle: 'Coffee shop renderings with 360° presentation',
  tags: ['floorplans', 'interiordesign'],

  images: {
    hero: coffeeShop,
    aboutTop: coffeeShopHow,
    aboutBottom: coffeeShopResult,
  },

  howText:
    'We designed coffee shop floor plan and layouts for coffee shops considering customer and staff flow. 2D and 3D coffee shop floor plans provide accurate dimensions and furniture placement. Coffee shop interior designs include materials, lighting, and decor choices.',

  resultText:
    'Clients receive ready-to-use plans for presentations, marketing, and quick project launch, attracting investors and speeding up café opening.',

  resultExtraText: 'Additionally, we provide:',
  resultList: [
    '2D floor plans for all levels,',
    'a complete 3D visualization of the house,',
    'and a 360° video tour that allows viewers to virtually walk through the space.',
  ],

  tourUrl: null,
  related: [],
};
